import { Select, Button } from 'antd';
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons';
import { ROLES } from '../constants';

export const FilterSelect = ({
    placeholder,
    options = [],
    value,
    onChange,
    width = 180,
    mode = "multiple",
}) => (
    <Select
        mode={mode}
        allowClear
        showSearch
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        options={options.map(o => typeof o === 'string' ? { label: o, value: o } : o)}
        style={{ width }}
        maxTagCount="responsive"
    />
);

export const EquipmentFilterBar = ({
    userRole,
    options = { types: [], vehicles: [], owners: [], plantUsers: [], plantHods: [] },
    filters = { types: [], vehicles: [], owners: [], plantUsers: [], plantHods: [] },
    onFilterChange,
    onRefresh,
    loading = false,
    showAddEquipModal
}) => (
    <div className="flex justify-between mb-4 flex-wrap gap-2">
        <div className="flex space-x-2 flex-wrap gap-y-2">
            <FilterSelect
                placeholder="Filter by Type"
                options={options.types}
                value={filters.types}
                onChange={(val) => onFilterChange({ ...filters, types: val })}
            />
            <FilterSelect
                placeholder="Filter by Vehicle"
                options={options.vehicles}
                value={filters.vehicles}
                onChange={(val) => onFilterChange({ ...filters, vehicles: val })}
            />
            {userRole != ROLES.OWNER &&
                <FilterSelect
                    placeholder="Filter by Owner"
                    options={options.owners}
                    value={filters.owners}
                    onChange={(val) => onFilterChange({ ...filters, owners: val })}
                />
            }
            {[ROLES.SPEND_TEAM, ROLES.ACCOUNT_TEAM, ROLES.PLANT_HOD].includes(userRole) ?
                <FilterSelect
                    placeholder="Filter by Plant User"
                    options={options.plantUsers}
                    value={filters.plantUsers}
                    onChange={(val) => onFilterChange({ ...filters, plantUsers: val })}
                /> : []}
            {[ROLES.SPEND_TEAM, ROLES.ACCOUNT_TEAM].includes(userRole) ?
                <FilterSelect
                    placeholder="Filter by Plant HOD"
                    options={options.plantHods}
                    value={filters.plantHods}
                    onChange={(val) => onFilterChange({ ...filters, plantHods: val })}
                /> : []}
        </div>
        <div className='flex gap-2'>
            <Button onClick={onRefresh} loading={loading} icon={<ReloadOutlined />} className='p-2.5'>
                Refresh
            </Button>
            {[ROLES.SPEND_TEAM, ROLES.PLANT_USER, ROLES.PLANT_HOD].includes(userRole) ?
                <Button
                    type='primary'
                    danger
                    onClick={showAddEquipModal}
                    className='font-semibold'
                    icon={<PlusOutlined
                        style={{
                            stroke: 'currentColor',
                            strokeWidth: 50,
                        }}
                    />}>
                    Add Equipment
                </Button> : []
            }
        </div>
    </div>
);

export const UserFilterBar = ({
    userRole,
    options = { email: [], role: [], plantHods: [] },
    filters = { email: [], role: [], plantHods: [] },
    onFilterChange,
    onRefresh,
    loading = false,
    showAddUserModal
}) => (
    <div className="flex justify-between mb-4 flex-wrap gap-2">
        <div className="flex space-x-2 flex-wrap gap-y-2">
            <FilterSelect
                placeholder="Filter by Email"
                options={options.email}
                value={filters.email}
                onChange={(val) => onFilterChange({ ...filters, email: val })}
            />
            {[ROLES.SPEND_TEAM, ROLES.ACCOUNT_TEAM].includes(userRole) &&
                <>
                    <FilterSelect
                        placeholder="Filter by Role"
                        options={options.role}
                        value={filters.role}
                        onChange={(val) => onFilterChange({ ...filters, role: val })}
                    />
                    <FilterSelect
                        placeholder="Filter by Plant HOD"
                        options={options.plantHods}
                        value={filters.plantHods}
                        onChange={(val) => onFilterChange({ ...filters, plantHods: val })}
                    />
                </>
            }
        </div>
        <div className='flex gap-2'>
            <Button onClick={onRefresh} loading={loading} icon={<ReloadOutlined />}>
                Refresh
            </Button>
            <div className='flex gap-2'>
                {[ROLES.SPEND_TEAM, ROLES.PLANT_HOD, ROLES.PLANT_USER].includes(userRole) &&
                    <Button
                        type='primary'
                        danger
                        onClick={showAddUserModal}
                        className='font-semibold'
                        icon={<PlusOutlined
                            style={{
                                stroke: 'currentColor',
                                strokeWidth: 50,
                            }}
                        />}>
                        {userRole == ROLES.SPEND_TEAM && "Add User"}
                        {userRole == ROLES.PLANT_HOD && "Add Plant User"}
                        {userRole == ROLES.PLANT_USER && "Add owner"}
                    </Button>
                }

            </div>
        </div>
    </div>
);
